import { all, put, takeEvery } from 'redux-saga/effects';
import { api } from '~/services/api';
import { CPF_RESPONSE } from './actionType';
import { cadastro_pessoa_error } from './action';

function* cpfWorker({ pessoa }) {
  try {
    const response = yield api.post('/pessoa_fisica', pessoa);
    console.log(response);
  } catch (err) {
    let server_errors = {};
    const response_errors = err.response.data.errors;
    for (let name of Object.keys(response_errors)) {
      Object.assign(server_errors, { [name]: response_errors[name][0] });
    }
    yield put(cadastro_pessoa_error(server_errors));
  }
}

function* watcherCpf() {
  yield takeEvery(CPF_RESPONSE, cpfWorker);
}

export default function* saga() {
  yield all([watcherCpf()]);
}
